// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"20be9f55","787":"0f1aff6b"}[chunkId] + ".chunk.js";
};